import { Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { IconAdjustmentsHorizontal, IconCircleX, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import moment from "moment";
import React, { forwardRef, useEffect, useState, } from "react";
import { connect } from "react-redux";
import { setAppVersionFilteredData } from "store/app/app-management/app-version/actions";
import { getRoleOptions } from "store/app/user-management/actions";

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterAppVersion = (props) => {

    const { open, onClose, appVersionFilterData } = props;

    const [filter, setFilter] = useState();

    useEffect(() => {
        if (appVersionFilterData) {
            setFilter(appVersionFilterData)
        }
        else {
            setFilter(null);
        }
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value
        })
    }

    const validateOnDate = (name, date) => {
        const formattedDate = date ? moment(date).format("DD-MM-YYYY") : null;
        setFilter({
            ...filter,
            [name]: formattedDate
        })
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setAppVersionFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setAppVersionFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'xs'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} columnSpacing="16" justifyContent='center' direction='column'>
                                            <Grid item>
                                                <TextField
                                                    autoFocus
                                                    label="Version No"
                                                    fullWidth
                                                    size="small"
                                                    name='versionno'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.versionno}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="App Name"
                                                    fullWidth
                                                    size="small"
                                                    name='appname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.appname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="Released Date"
                                                        onChange={(date) => validateOnDate("releaseddate", date)}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.releaseddate ? moment.utc(filter?.releaseddate, "DD-MM-YYYY") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Notes"
                                                    fullWidth
                                                    size="small"
                                                    name='notes'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.notes}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Created By"
                                                    fullWidth
                                                    size="small"
                                                    name='createdby'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.createdby}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="Created On"
                                                        onChange={(date) => validateOnDate("createdon", date)}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.createdon ? moment.utc(filter.createdon, "DD-MM-YYYY") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            field: { clearable: true },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Updated By"
                                                    fullWidth
                                                    size="small"
                                                    name='updatedby'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.updatedby}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DatePicker
                                                        label="Updated On"
                                                        onChange={(date) => validateOnDate("updatedon", date)}
                                                        fullWidth
                                                        format="DD/MM/YYYY"
                                                        value={filter?.updatedon ? moment.utc(filter.updatedon, "DD-MM-YYYY") : null}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                            },
                                                            field: { clearable: true },

                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid container justifyContent={'right'}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleFilter}
                                                    size="small"
                                                    color="primary"
                                                    startIcon={<IconAdjustmentsHorizontal />}
                                                >
                                                    Apply Filters
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleFilterClear}
                                                    sx={{ ml: 2 }}
                                                    color='error'
                                                    size="small"
                                                    startIcon={<IconCircleX />}
                                                >
                                                    Clear
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    appVersionFilterData: state.appVersions.appVersionFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setAppVersionFilteredData: (filter) => dispatch(setAppVersionFilteredData(filter)),
    getRoleOptions: () => dispatch(getRoleOptions()),

})

export default connect(mapStateToProps, mapDispatchToProps)(FilterAppVersion);